import jQuery from 'jquery';

export class TH_BsButton {
    constructor(dom) {
        this.elem = dom;

        this.elem.data('bs-button-object', this);
        this.originalText = this.elem.html();
        this.lock = {
            'disable-status': false
        };
    }

    /** Disable the button
     * 
     */
    disable() {
        if (this.lock['disable-status'] === false) this.elem.prop('disabled', true);
    }

    /** Enable the button
     * 
     */
    enable() {
	    if (this.lock['disable-status'] === false) this.elem.prop('disabled', false);
    }

    /** Lock the status of this button
     * 
     */
    lockStatus() {
        this.lock[status]=true;
    }

    /** Unlock the status of this button
     * 
     */
    unlockStatus() {
        this.lock[status]=false;
    }

    /** Start the loading animation on this button
     * 
     */
    startLoading() {
        this.disable();
        this.elem.addClass('running');
    }

    /** Stop the loading animation on this button
     * 
     */
    stopLoading() {
        this.elem.removeClass('running');
        this.enable();
    }

    static getBSButton(elem) {
        if (typeof elem.data('bs-button-object') === 'undefined' || elem.data('bs-button-object') == '') new BsButton(elem);

	    return elem.data('bs-button-object');
    }
}

export default TH_BsButton;

